import React, { FC } from "react";
import { Button, Colors } from "@blueprintjs/core";
import copy from "copy-to-clipboard";
import styled from "styled-components";

import toasts from "../utils/toasts";

type CopyIDButtonProps = {
  id: string;
  children?: React.ReactNode;
  toastText?: string;
};


const CopyIDButton: FC<CopyIDButtonProps> = ({
  id,
  children = <DefaultIDButtonTextWrapper>{id}</DefaultIDButtonTextWrapper>,
  toastText = "Copied ID to clipboard!",
}) => {
  const onClick = React.useCallback(() => {
    copy(id);
    toasts.success(toastText);
  }, [id, toastText]);
  return (
    <CustomCopyID>
      {children}
      <Button minimal small rightIcon="clipboard" onClick={onClick} />
    </CustomCopyID>
  );
};

export default CopyIDButton;

const CustomCopyID = styled.span`
  gap: 0.5rem;
  color: ${({ theme: { darkMode } }) =>darkMode ? Colors.GRAY4 : Colors.GRAY1};  
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 100px;
  margin: auto;
  padding-top: 3px;
  padding-bottom: 3px;
`;
export const DefaultIDButtonTextWrapper = styled.small`
  overflow: hidden;
  width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
`;
